import { makeAutoObservable } from 'mobx';

export default class Storage {
  storage = {};

  constructor() {
    makeAutoObservable(this);
  }

  addItem = (id, data) => {
    this.storage[id] = data;
  };

  getItem = id => {
    return this.storage[id];
  };
}
